import goldIconPng from "../assets/GoldIcon.png";

import { createBitmapIcon } from "./createBitmapIcon";

export const GoldIcon = createBitmapIcon({
  alt: "Gold",
  displayName: "GoldIcon",
  src: goldIconPng,
});
